var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_3922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3054 1.9846C13.1033 1.78248 12.7756 1.78248 12.5735 1.9846L4.18356 10.3745L0.883553 7.07449C0.681461 6.87235 0.353734 6.87235 0.151589 7.07449C-0.0505297 7.27661 -0.0505297 7.60431 0.151589 7.80646L3.81761 11.4725C4.01965 11.6745 4.34748 11.6746 4.54958 11.4725L13.3054 2.71656C13.5075 2.51442 13.5075 2.18672 13.3054 1.9846Z",
    fill: "#4B1498"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_3922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.457,
    height: 13.457,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.ec00bd1c64baad9fe1ab7f0f6e5ac5d8.svg";
export { ForwardRef as ReactComponent };